<template>
  <v-container>
    <h2>{{$t('status.title')}}</h2>
    <h4>{{$t('status.note')}}</h4>
    <v-divider class="my-4" />
    <h3>{{$t('status.gameServer')}}</h3>
    <v-row>
      <v-col cols="4" md="12">
        <v-card>
          <v-card-title>MAKjust Ruby Server</v-card-title>
          <v-card-text>{{$t('status.gameServer_status')}}NULL  {{$t('status.gameServer_live')}}N/A</v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <h3>{{$t('status.dataServer')}}</h3>
    <v-alert v-if="monitors === 0" color="info" dark><v-progress-circular indeterminate color="white" style="margin-right:10px;"></v-progress-circular>正在获取状态监控服务数据</v-alert>
    <v-alert v-else-if="monitors === false" type="error" dark>{{$t('status.dataServer_error')}}</v-alert>
    <v-card class="ma-2" v-for="(monitor, i) in monitors" :key="`_STATUSPAGE-MONITOR-${i}`">
      <v-card-title>
        {{monitor.friendly_name}}
        <v-spacer></v-spacer>
        <v-chip v-if="monitor.status === 2" color="success">
          <v-icon left>done</v-icon>{{$t('status.dataServer_online')}}
        </v-chip>
        <v-chip v-else color="success">
          <v-icon left>warning</v-icon>{{$t('status.dataServer_offline')}}
        </v-chip>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        {{$t('status.dataServer_60day')}}
        <v-progress-linear
          height="16"
          :value="monitor.custom_uptime_ratio"
          color="teal"
          dark
        >{{ monitor.custom_uptime_ratio }}%</v-progress-linear>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import uptime from "@/plugins/uptime";

export default {
  name: "STATUS",
  data() {
    return {
      monitors: 0
    };
  },
  mounted() {
    uptime
      .getMonitors(
        "ur905016-dbca877e9557fd77e23f63ad",
        "785309261-785309266-784736854-785309285"
      )
      .then(data => {
        this.monitors = data;
      });
  }
};
</script>